<template>
  <TopBar title="What is the highest level of study you have attempted or completed?" subtitle="testing" :step="step"/>
  <div class="step">
    <div v-for="(field, index) in fields" :key="field.value">
      <button class="btn-select level-of-study" @click="toggleSelect(index)" :class="{ selected: field.value === selected }">
        <div class="icon" v-if="field.svg !== false" v-html="field.svg"></div>
        <div class="text" v-html="field.title" :class="{ 'text-center' : fields.length - 1 === index }"></div>
      </button>
    </div>
  </div>
  <BottomBar :step="step" :show-next="false"/>
</template>
<script>
import { mapState } from 'vuex'

import TopBar from '@/components/TopBar'
import BottomBar from '@/components/BottomBar'

export default {
  props: {
    step: {
      required: true
    }
  },
  components: {
    TopBar,
    BottomBar
  },
  computed: mapState({
    selected: state => state.formData.levelOfStudy
  }),
  data () {
    return {
      fields: [
        {
          title: 'Tertiary <br>(Higher Education Provider)',
          value: 'Tertiary',
          svg: '<svg width="94" height="65" viewBox="0 0 94 65" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M90.2016 15.1895L48.6614 0.288399C47.5732 -0.103353 46.398 -0.088844 45.3243 0.288399L3.78406 15.1895C1.8253 15.8859 0.562988 17.6706 0.562988 19.6003C0.562988 21.5301 1.8253 23.4453 3.78406 24.1417L7.52747 25.6217V42.0317L2.94252 62.1707C2.78292 62.8671 2.94252 63.5781 3.39231 64.1294C3.82759 64.6808 4.49502 65 5.20597 65H14.4919C15.2029 65 15.8703 64.6808 16.3056 64.1294C16.7409 63.5781 16.915 62.8526 16.7554 62.1707L12.1705 41.727V27.2757L45.3243 39.1734C45.8611 39.362 46.427 39.4491 46.9928 39.4491C47.5587 39.4491 48.1246 39.3475 48.6759 39.1589L90.2016 24.2578C92.1749 23.5614 93.4372 21.7767 93.4372 19.5858C93.4227 17.4094 92.1604 15.8859 90.2016 15.1895ZM46.8913 34.8061L19.3526 24.9252L47.6748 16.1471C48.8936 15.7699 49.59 14.4785 49.2128 13.2452C48.8355 12.0264 47.5442 11.33 46.3109 11.7217L12.0834 22.3136L5.20597 19.7309L47.0944 4.65571L88.7797 19.7309L46.8913 34.8061Z" fill="black"/><path d="M70.5415 37.1566C69.2647 37.3307 68.3797 38.4914 68.5393 39.7682L70.1933 52.3333C70.3674 53.6246 69.5114 54.9015 68.0459 55.5689C61.6764 58.5143 54.4652 60.1683 47.2686 60.3425H46.7753C39.5206 60.1683 32.3095 58.5143 25.9399 55.5689C24.4744 54.8869 23.6329 53.6246 23.7925 52.3333L25.4466 39.7682C25.6207 38.4914 24.7211 37.3307 23.4443 37.1566C22.1529 36.9824 21.0067 37.8965 20.8471 39.1588L19.193 51.7384C18.7578 55.0756 20.644 58.2531 23.9956 59.7911C30.9456 62.9977 38.7806 64.8113 46.7172 65H47.3121C55.2052 64.8113 63.0402 62.9977 69.9757 59.7911C73.3273 58.2386 75.2136 55.0756 74.7783 51.7239L73.1242 39.1443C72.9791 37.8965 71.8184 36.9824 70.5415 37.1566Z" fill="#DA2E2E"/></svg>'
        },
        {
          title: 'Tertiary <br>(Registered Training Provider)',
          value: 'Training',
          svg: '<svg width="93" height="65" viewBox="0 0 93 65" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M78.3182 16.25H69.2646C70.2802 14.5379 70.8751 12.5212 70.8751 10.4464C70.8751 4.68638 66.7546 0 61.6764 0C57.2512 0 54.2189 1.42187 46.5001 14.0592C38.7814 1.42187 35.749 0 31.3238 0C26.2456 0 22.1251 4.68638 22.1251 10.4464C22.1251 12.5212 22.72 14.5379 23.7501 16.25H14.0001C6.31037 16.25 0.0715332 23.2868 0.0715332 34.8214C0.0715332 46.356 6.31037 55.7143 14.0001 55.7143L34.893 51.231V46.4866L13.5939 51.0569C9.31372 50.6652 4.71439 43.9766 4.71439 34.8214C4.71439 26.6239 8.53024 20.8929 14.0001 20.8929H34.893H39.5358H53.4644H58.1072H78.3182C84.2813 20.8929 88.2858 26.4933 88.2858 34.8214C88.2858 43.3962 83.9622 50.6797 78.7389 51.0569L58.1072 46.5446V51.2891L78.3182 55.7143C86.3851 55.7143 92.9287 46.356 92.9287 34.8214C92.9287 23.2868 86.3851 16.25 78.3182 16.25ZM31.3238 16.25C28.8137 16.25 26.768 13.6529 26.768 10.4464C26.768 7.23996 28.8137 4.64286 31.3238 4.64286C33.355 4.64286 35.2992 4.67187 42.4086 16.25H31.3238ZM61.6764 16.25H50.6061C57.7155 4.67187 59.6452 4.64286 61.691 4.64286C64.1865 4.64286 66.2322 7.25446 66.2322 10.4464C66.2322 13.6384 64.1865 16.25 61.6764 16.25Z" fill="black"/><path d="M58.1074 20.8928H53.4645V58.9207L47.5449 55.9609C46.892 55.6417 46.123 55.6417 45.4701 55.9609L39.5359 58.9207V20.8928H34.8931V46.4866V51.231V62.6785C34.8931 63.4765 35.3138 64.231 35.9957 64.6518C36.6777 65.058 37.5337 65.116 38.2591 64.7533L46.5002 60.6328L54.7413 64.7533C55.075 64.9129 55.4377 65 55.7859 65C56.2067 65 56.6274 64.8839 57.0047 64.6518C57.6866 64.231 58.1074 63.4765 58.1074 62.6785V51.289V46.5446V20.8928Z" fill="#DA2E2E"/></svg>'
        },
        {
          title: 'Completed year 12, <br>STAT test (or equivalent)',
          value: 'High School',
          svg: '<svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.9103 43.0626C32.218 41.7169 32.7385 39.7491 32.256 37.921C31.9133 36.2071 31.799 36.9181 32.3703 35.2042C32.8527 33.3507 32.3322 31.3829 31.0119 30.0499C29.7551 28.7931 29.7678 28.9962 29.425 27.2823C28.9553 25.4415 27.5334 23.88 25.7053 23.4991C24.0041 23.0294 24.2326 23.1817 22.9885 21.8868C21.6555 20.5284 19.7004 19.9952 17.8722 20.4903C16.1711 20.9601 16.4377 20.9474 14.7492 20.4903C12.9084 19.9952 10.9533 20.5411 9.6203 21.8868C8.36346 23.1817 8.59198 23.0294 6.89081 23.4991C5.06268 23.9942 3.64081 25.4415 3.17108 27.295C2.71405 28.9962 2.841 28.7931 1.59686 30.0499C0.276547 31.3702 -0.256656 33.3507 0.238461 35.2042C0.695493 36.9181 0.695493 36.2071 0.238461 37.921C-0.243961 39.7491 0.263852 41.7169 1.58416 43.0626C2.8537 44.3448 2.71405 44.1036 3.17108 45.8556C3.6662 47.6837 5.10077 49.131 6.9035 49.6261C7.56366 49.8038 7.89373 49.9054 8.17303 50.0196V62.9688C8.17303 63.6671 8.5412 64.3272 9.13788 64.6954C9.73456 65.0636 10.4836 65.1017 11.1183 64.7843L16.298 62.1944L21.4904 64.7843C21.7697 64.9239 22.0998 65.0001 22.3918 65.0001C22.7599 65.0001 23.1281 64.8985 23.4582 64.6954C24.0549 64.3272 24.423 63.6671 24.423 62.9688V50.1339C24.7023 50.0196 25.0451 49.9181 25.6926 49.7403C27.508 49.2452 28.9426 47.8106 29.425 45.9698C29.8947 44.1036 29.7424 44.3448 30.9103 43.0626ZM20.3605 59.6808L17.2121 58.1065C16.6408 57.8272 15.968 57.8272 15.3967 58.1065L12.2355 59.6808V52.6602C13.048 52.838 13.9113 52.8507 14.7365 52.6349C16.4758 52.1651 16.133 52.1651 17.8596 52.6349C18.6848 52.8634 19.548 52.8507 20.3605 52.6602V59.6808ZM27.7873 40.5616C26.3273 42.0343 26.1496 42.3643 25.5148 44.8145C25.3117 45.5636 24.7277 45.6905 24.2072 45.8302C22.2014 46.3761 21.884 46.5665 20.3859 48.0772C19.7004 48.7755 19.5353 48.877 18.5197 48.5977C16.5012 48.0518 16.1076 48.0392 14.089 48.5977C13.0734 48.877 12.9084 48.7755 12.2228 48.0772C10.7375 46.5665 10.4201 46.3761 8.40155 45.8302C7.88104 45.6905 7.28436 45.5636 7.09393 44.8145C6.47186 42.3643 6.28143 42.047 4.82147 40.5616C3.9328 39.6729 4.02166 39.4698 4.31366 38.3526C4.7453 36.7276 4.7453 36.3595 4.31366 34.7599C4.03436 33.7061 3.9201 33.4649 4.77069 32.6144C6.26873 31.1036 6.44647 30.7862 6.97967 28.755C7.24627 27.7267 7.32245 27.587 8.38885 27.295C10.4074 26.7491 10.7248 26.5587 12.2101 25.0352C12.883 24.3497 13.0607 24.2481 14.0764 24.5274C16.1203 25.086 16.4631 25.086 18.507 24.5274C19.5226 24.2481 19.7004 24.3497 20.3732 25.0352C21.8586 26.546 22.176 26.7364 24.1945 27.295C25.2609 27.587 25.3371 27.7394 25.6037 28.755C26.1369 30.7862 26.3273 31.1036 27.8127 32.6144C28.6633 33.4649 28.549 33.7061 28.2697 34.7472C27.8254 36.3595 27.8254 36.7276 28.2697 38.3526C28.5744 39.4698 28.676 39.6602 27.7873 40.5616Z" fill="#DA2E2E"/><path d="M62.6739 15.9072L49.1534 2.38672C47.6173 0.850586 45.5607 0 43.4025 0H24.3087C19.8146 0 16.1837 3.64355 16.1837 8.125L16.298 14.2188C16.298 15.3359 17.212 16.25 18.3292 16.25C19.4464 16.25 20.3605 15.3359 20.3605 14.2188V8.125C20.3605 5.87793 22.1759 4.0625 24.423 4.0625H40.673V18.2812C40.673 21.6455 43.4025 24.375 46.7667 24.375H60.9855V56.875C60.9855 59.1221 59.17 60.9375 56.923 60.9375H30.5167C29.3995 60.9375 28.4855 61.8516 28.4855 62.9688C28.4855 64.0859 29.3995 65 30.5167 65H56.8087C61.2902 65 64.9337 61.3691 64.9337 56.875V21.6455C65.048 19.4873 64.1974 17.4307 62.6739 15.9072ZM46.7667 20.3125C45.6495 20.3125 44.7355 19.3984 44.7355 18.2812V4.3291C45.3068 4.53223 45.84 4.81152 46.2716 5.25586L59.7921 18.7764C60.2365 19.208 60.5284 19.7412 60.7189 20.3125H46.7667Z" fill="black"/></svg>'
        },
        {
          title: 'Work Experience / Other',
          value: 'Work Experience',
          svg: '<svg width="82" height="65" viewBox="0 0 82 65" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.5272 0.485667C30.289 -0.161889 31.4064 -0.161889 32.1682 0.485667L60.6098 24.8642C61.4606 25.588 61.5621 26.8704 60.8257 27.7211C60.4321 28.1909 59.8734 28.3179 59.302 28.3179H59.2766C58.8069 28.3179 58.3498 28.2671 57.9688 27.937L53.1947 23.8485V28.3179H49.1316V20.3694L30.8477 4.70113L12.5638 20.3694V44.6845C12.5638 46.9319 14.3795 48.7476 16.6269 48.7476H34.9108V52.8107H16.6269C12.1447 52.8107 8.50066 49.1666 8.50066 44.6845V23.8485L3.72652 27.937C2.87581 28.6734 1.5934 28.5718 0.856964 27.7211C0.120528 26.8704 0.222106 25.588 1.07282 24.8642L29.5272 0.485667Z" fill="black"/><path d="M69.4471 32.4951C72.8119 32.4951 75.5417 35.225 75.5417 38.5898V54.8421C75.5417 55.9595 74.6276 56.8737 73.5102 56.8737C72.3928 56.8737 71.4787 55.9595 71.4787 54.8421V38.5898C71.4787 37.4724 70.5645 36.5582 69.4471 36.5582H45.0685C43.9512 36.5582 43.037 37.4724 43.037 38.5898V54.8421C43.037 55.9595 42.1228 56.8737 40.8912 56.8737C39.8881 56.8737 38.8596 55.9595 38.8596 54.8421V38.5898C38.8596 35.225 41.7038 32.4951 45.0685 32.4951H69.4471Z" fill="#DA2E2E"/><path d="M79.6048 60.9368C80.7221 60.9368 81.6363 61.851 81.6363 62.9683C81.6363 64.0857 80.7221 64.9999 79.6048 64.9999H34.7964C33.7934 64.9999 32.7649 64.0857 32.7649 62.9683C32.7649 61.851 33.7934 60.9368 34.7964 60.9368H79.6048Z" fill="#DA2E2E"/><path d="M34.7965 22.3376C37.1581 22.3376 38.8596 24.1533 38.8596 26.4007V28.4323C38.8596 29.5496 38.0596 30.4638 36.828 30.4638C35.8249 30.4638 34.7965 29.5496 34.7965 28.4323V26.4007H26.6703V34.5269H32.7649C33.9965 34.5269 34.7965 35.4411 34.7965 36.5585C34.7965 37.6758 33.9965 38.59 32.7649 38.59H26.6703C24.5371 38.59 22.6072 36.7743 22.6072 34.5269V26.4007C22.6072 24.1533 24.5371 22.3376 26.6703 22.3376H34.7965Z" fill="black"/></svg>'
        },
        {
          title: 'None',
          value: false,
          svg: false
        }
      ]
    }
  },
  methods: {
    toggleSelect (index) {
      if (this.fields[index].value === false || this.fields[index].value === 'Work Experience') {
        this.$router.push('/step/7')
      }
      if (this.fields[index].value === 'High School') {
        this.$router.push('/step/6')
      }
      if (this.fields[index].value === 'Tertiary' || this.fields[index].value === 'Training') {
        this.$router.push('/step/5')
      }
      this.$store.commit('setFormData', { key: 'levelOfStudy', value: this.fields[index].value })
    }
  }
}
</script>
<style lang="scss">
@import './../assets/scss/mixins';

.step-4 {
  .step {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    // padding-left: 6rem;
    // padding-right: 6rem;

    > div {
      flex-basis: 100%;
      flex-grow: 0;
      display: flex;
      min-height: 98px;

      @include respond-above(lg) {
        min-height: 215px;
      }

      svg {
        width: 40px;
        height: auto;
      }

      button.level-of-study {
        width: 100%;
        flex-direction: row !important;

        @include respond-above(lg) {
          flex-direction: column !important;
        }

        .icon {
          margin-right: 1rem;
          margin-bottom: 0;
        }

        .text {
          flex-grow: 1;
          text-align: left !important;

          @include respond-above(lg) {
            text-align: center !important;
          }

          &.text-center {
            flex-grow: unset !important;
            text-align: center !important;
          }
        }
      }

      @include respond-above(lg) {
        flex-basis: 33.33333%;
        //aspect-ratio: 1.63;

        svg {
          width: auto;
        }

        button {
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .icon {
            margin-right: 0;
            margin-bottom: 0.75rem;
          }

          .text {
            justify-content: center;
            text-align: center;
            flex-grow: 0;
          }
        }
      }
    }
  }
}
</style>
